import utils from './index';
import wxPackage from './wxpackage';

class Locator {
  constructor() {
    /**
     * status
     * 0 init
     * 1 complete
     * 2 pending
    */
    this.status = 0;
    this.promises = [];
    this.locateResult = null;
    this.timeout = null;
  }

  returnResult() {
    // 返回结果
    this.status = 1;
    for (let i = 0; i < this.promises.length; i += 1) {
      const func = this.promises[i];
      if (typeof func === 'function') {
        func(this.locateResult);
      }
    }
    this.promises = [];
    // 内存默认10s过期，之后重置状态
    if (!this.timeout) {
      this.timeout = setTimeout(() => {
        this.locateResult = null;
        this.status = 0;
        clearTimeout(this.timeout);
        this.timeout = null;
      }, 10000);
    }
  }

  getLocation(agent) {
    return new Promise((resolve, reject) => {
      let isInitial = false;
      // 处理结果方法
      const complete = (res) => {
        if (this.locateResult !== res) {
          this.locateResult = res;
        }
        if (isInitial) {
          this.returnResult();
        }
        if (typeof res === 'string' || res === false) {
          reject(new TypeError(res || '定位失败'));
        } else {
          resolve(res);
        }
      };
      if (this.status === 0) {
        // 初始状态
        isInitial = true;
        this.status = 2;
      } else if (this.status === 2) {
        // pending状态等待returnResult返回结果
        if (utils.agent === 'mp') {
          complete(false);
        } else {
          this.promises.push(complete);
        }
        return;
      } else {
        // 已完成状态
        if (this.locateResult || this.locateResult === false) {
          // 使用内存
          complete(this.locateResult);
        }
        return;
      }
      if (agent) {
        switch (agent) {
          case 'mp':
            this._getLocationByMp(complete);
            break;
          case 'native':
            this._getLocationByNative(complete);
            break;
          case 'wap':
            this._getLocationByAmap(complete);
            break;
          default:
            break;
        }
        return;
      }
      if (utils.agent === 'native') {
        this._getLocationByNative(complete);
      } else if (utils.agent === 'mp' || window.navigator.userAgent.includes('MicroMessenger')) {
        this._getLocationByMp(complete);
      } else {
        this._getLocationByAmap(complete);
      }
    });
  }

  _getLocationByNative(callback) {
    const location = {
      lat: 0,
      lng: 0,
      cityName: '',
      provinceName: '',
    };
    window.getLocation((data) => {
      console.log(data);
      if (data && data.success) {
        location.cityName = data.cityName;
        location.provinceName = data.provinceName;
        location.lat = data.latitude;
        location.lng = data.longitude;
        callback(location);
      } else {
        callback(false);
        // callback({
        //   provinceName: "",
        //   cityName: "上海市",
        //   provinceId:10000000000019,
        //   cityId: 10000000000335
        // });
      }
    });
    return this;
  }

  _getLocationByMp(callback) {
    const location = {
      lat: 0,
      lng: 0,
      cityName: '',
      provinceName: '',
    };
    const _getAddress = () => {
      console.log('_getAddress--------------');
      const getAddress = (lat, lng) => {
        // 地址和经纬度之间进行转换服务
        const geocoder = qq.maps.Geocoder ? new qq.maps.Geocoder() : window.qqGeocoder;
        // 设置服务请求成功的回调函数
        geocoder.setComplete((result) => {
          console.log('qqmap address;>>>>');
          console.log(result);

          const {
            address,
            addressComponents,
          } = result.detail;
          // addressComponents : {city: "北京市"country: "中国"district:
          // "东城区"province: "北京市"street: "正义路"streetNumber: "正义路2号"town: "东华门街道"village: ""}

          const locationObj = {
            formattedAddress: address,
            provinceName: addressComponents.province,
            cityName: addressComponents.city,
          };
          if (locationObj.cityName === '') {
            locationObj.cityName = locationObj.provinceName;
          }
          location.cityName = locationObj.cityName;
          location.provinceName = locationObj.provinceName;
          // 回传小程序城市信息
          const locationDone = true;
          const selfCityParams = {
            lat, // 纬度
            lng, // 经度
            province: locationObj.provinceName,
            city: locationObj.cityName,
          };
          wx.miniProgram.postMessage({
            data: {
              locationDone,
              selfCityParams,
            },
          });
          callback(location);
        });
        // 若服务请求失败，则运行以下函数
        geocoder.setError(() => {
          callback('腾讯地图省市定位失败');
        });
        const latLng = new qq.maps.LatLng(lat, lng);
        geocoder.getAddress(latLng);
      };
      wx.getLocation({
        type: 'gcj02',
        success(res) {
          console.log('wxGetLocationSuccess');
          location.lat = res.latitude;
          location.lng = res.longitude;
          getAddress(res.latitude, res.longitude);
        },
        cancel(res) {
          console.log('wxGetLocationCancel');
          console.log(res);
        },
        fail(res) {
          console.log('wxGetLocationFail');
          console.log(res);
        },
        error(res) {
          console.log('wxGetLocationError');
          console.log(res);
        },
      });
    };
    wxPackage.execute('_getAddress', _getAddress);
    return this;
  }

  _getLocationByAmap(callback) {
    let location = {
      lat: 0,
      lng: 0,
      cityName: '',
      provinceName: '',
    };
    const func = () => {
      const { AMap } = window;
      AMap.plugin('AMap.Geolocation', () => {
        const gdGeolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          timeout: 10000,
          buttonOffset: new AMap.Pixel(10, 20),
          zoomToAccuracy: true,
          buttonPosition: 'RB',
        });
        gdGeolocation.getCurrentPosition();
        AMap.event.addListener(gdGeolocation, 'complete', (data) => {
          console.log(data);
          console.log(gdGeolocation);
          if (data.formattedAddress && data.addressComponent) {
            location = {
              lat: data.position.getLat(), // 纬度
              lng: data.position.getLng(), // 经度
              formattedAddress: data.formattedAddress,
              provinceName: data.addressComponent.province,
              cityName: data.addressComponent.city,
            };
            if (location.cityName === '') {
              location.cityName = location.provinceName;
            }

            callback(location);
          } else {
            AMap.plugin('AMap.CitySearch', () => {
              const citySearch = new AMap.CitySearch();
              citySearch.getLocalCity((status, result) => {
                if (status === 'complete' && result.info === 'OK') {
                  // 查询成功，result即为当前所在城市信息
                  location = {
                    lat: data.position.getLat(), // 纬度
                    lng: data.position.getLng(), // 经度
                    provinceName: result.province,
                    cityName: result.city,
                  };
                  if (location.cityName === '') {
                    location.cityName = location.provinceName;
                  }
                  callback(location);
                } else {
                  location = {
                    lat: data.position.getLat(), // 纬度
                    lng: data.position.getLng(), // 经度
                  };
                  callback(location);
                }
              });
            });
          }
        });
        AMap.event.addListener(gdGeolocation, 'error', () => {
          callback({
            provinceName: '上海市',
            cityName: '上海市',
            provinceId: 10000000000019,
            cityId: 10000000000335,
            lat: 31.220224,
            lng: 121.199535,
          });
        });
      });
    };
    if (window.AMap) {
      func();
    } else {
      document.addEventListener('amapready', func);
    }
    return this;
  }
}

export default Locator;
